import React from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { envionContraseniaTemporal } from '../../actions/olvido_contrasenia/envioContraseniaTemporal';

export const FormCorreo = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validateOlvido = Yup.object({
        email: Yup.string().required('El campo es requerido').email('Ingrese un email válido')
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validateOlvido),
        mode: "onChange" 
    });

    const onSubmit = (data) => {
        const { email } = data;
        dispatch(envionContraseniaTemporal(email));
    }
    return (
        <Card className="card-login" >
            <Card.Body>
                <Card.Title>¿Olvidaste tu contraseña? 👀</Card.Title>
                <Card.Text>No te preocupes, a todos nos pasa.</Card.Text>
                <Card.Text>Déjanos tu email y te enviaremos una contraseña temporal.</Card.Text>

                <Form onSubmit={handleSubmit(onSubmit)} noValidate >
                    <Row>
                        <Form.Group as={Col} xs="12" className='mb-3'>
                            <Form.Label>Email</Form.Label>
                            <Form.Control 
                                type="email"
                                name="email"
                                placeholder="Ingresa tu email"
                                maxLength={100}
                                autoComplete="off"
                                autoCapitalize="none"
                                style={{ textTransform: "lowercase" }}
                                className={`${errors.email ? 'is-invalid' : ""}`}
                                {...register('email', {
                                    required: "El campo es requerido",
                                    onChange: (e) => {
                                        e.target.value = e.target.value.toLowerCase();
                                    }
                                })}
                            />
                            <p className='texto-error'>{errors.email?.message}</p>
                        </Form.Group>
                        
                        <Form.Group as={Col} xs="12" className="mt-4 ms-auto" >
                            <Button type="submit" className="btn btn-primary w-100" >Obtener contraseña temporal</Button>
                        </Form.Group>

                        <Form.Group as={Col} xs="12" className="mt-4 ms-auto" >
                            <Button type="submit" className="btn btn-light w-100" onClick={() => navigate("/login")} >Regresar</Button>
                        </Form.Group>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    )
}
